<script type="text/javascript">

const host = process.env.API_ROOT;
const imageRoot = process.env.IMAGE_ROOT;
const region = {}

export default
{
  host,
  imageRoot,
  region
}
</script>



// WEBPACK FOOTER //
// src/components/global.vue